module.exports = __webpack_public_path__ + "5bd4f0200ffd168102aa2e4b9a16ab83.svg";